export interface GenerateBookPresignedUrlResponse {
  id: string;
  signedUrl: string;
}

export interface BookStatusEntry {
  id: string;
  name: string;
  userId: string;
  statusId: BookStatus;
  statusDescription: string;
  uploadDate: string;
  date: string;
  client: string;
  color: string;
  access: string;
  errorMessage: string;
}

export enum DatasetTypes {
  Policies = "Policies",
  Claims = "Claims",
}

export enum BookStatus {
  Uploading = "Uploading",
  Initialising = "Initialising",
  Geocoding = "Geocoding",
  Tagging = "Tagging",
  Importing = "Importing",
  Failure = "Failure",
  Success = "Success",
  Deleted = "Deleted",
}

export enum Contexts {
  None = "",
  UniqueId = "UniqueId",
  SumInsured = "SumInsured",
  AddressId = "AddressId",
  AddressLine = "AddressLine",
  Address = "Address",
  Postcode = "Postcode",
  Latitude = "Latitude",
  Longitude = "Longitude",
}
